import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class Ac2DocumentConfigProvider extends HttpRequest {
  getDocumentConfigs (query) {
    this.setHeader(getAuthToken())
    return this.get('/ac2/document-configs', query)
  }

  getDocumentConfigById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/ac2/document-configs/${id}`)
  }

  updateDocumentConfigById (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/ac2/document-configs/${id}`, payload)
  }
}
